import { useTheme } from '@mui/material'

const useSharedStyles = () => {
    const theme = useTheme()
    const titleStyle = {
        typography: 'headline3',
        lineHeight: '28px',
    }
    const titleContainer = {
        display: 'flex',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.custom.neutralDark}`,
        paddingBottom: '24px',
    }
    const sectionStyle = {
        width: '100%',
        maxWidth: { xs: 'calc(100% - 16px)', md: '700px' },
        padding: '32px',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: 'custom.dropDownBackground',
        marginTop: '32px',
    }
    const container = {
        margin: '8px 16px 0px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        paddingBottom: '32px',
        maxHeight: 'calc(100vh - 90px)',
        overflowY: 'auto',
        width: '100%',
        height: '100vh',
        maxWidth: { xs: 'calc(100% - 32px)', md: '100%' },
    }
    const iconContainer = {
        width: '44px',
        height: '44px',
        padding: '12px',
        borderRadius: theme.shape.borderRadius,
        background: '#4D4D4D99',
    }
    const dataContainer = {
        marginTop: '24px',
    }
    const dataLineField = {
        color: 'greyFontColor',
        typography: 'text1',
        lineHeight: '19px',
    }
    const deviceCaptionStyle = {
        ...dataLineField,
        marginBottom: '24px',
    }

    return {
        titleStyle,
        titleContainer,
        sectionStyle,
        container,
        iconContainer,
        dataContainer,
        dataLineField,
        deviceCaptionStyle,
    }
}

export { useSharedStyles }
